<a matButton (click)="open()"
  ><mat-icon fontSet="material-symbols-outlined">table_chart</mat-icon>
  <span>Size Guide</span>
</a>
